function slugify(input) {
  return input
    .toLowerCase()
    .replace(/[^0-9a-z]+/g, '-')
    .replace(/^-+/g, '')
    .replace(/-+$/g, '')
}

export default slugify
